module.exports = __webpack_public_path__ + "img/processing.8622f2ca.svg";